export const PROGRESS_TYPES = {
  IDLE: 'IDLE',
  WORK: 'WORK',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export default PROGRESS_TYPES;
